<template>
  <v-app>
    <view-layout v-bind="$attrs" footer-color="primary" class="text-center pa-0 overflow-hidden" footer-class="text-left">
      <template v-if="$slots.title" slot="title">
        <text-h3 class="mt-3" style="width: 100%;">
          <slot name="title" />
        </text-h3>
      </template>

      <v-card v-if="!!$slots.body" flat tile class="text-left px-4 pb-4 pt-10" :style="$props.bgWhite ? 'background-color: white' : 'background-color: var(--v-primary-base)'" color="overflow-y-auto" style="height: 100%;">
        <slot name="body"></slot>
      </v-card>

      <template slot="footer">
        <v-row v-if="!!$slots.footer || !!$slots['footer-left'] || !!$slots['footer-right']" no-gutters align="center" :style="$props.bgWhite ? 'background-color: white' : 'background-color: var(--v-primary-base)'">

          <v-col v-if="!!$slots.footer" cols="12"><slot name="footer"></slot></v-col>

          <v-col v-if="!$slots.footer" cols="auto" class="mr-auto">
            <slot name="footer-left"></slot>
          </v-col>

          <v-col v-if="!$slots.footer" cols="auto">
            <slot name="footer-right"></slot>
          </v-col>
        </v-row>
      </template>
    </view-layout>
  </v-app>
</template>

<script>
export default {
  props: {
    bgWhite: {
      type: Boolean,
    },
  },
  data () {
    return {
      model: {},
    }
  }
};
</script>
